var options = ["Green", "Yellow", "Blue", "None"];
var validMedicareCardType = function validMedicareCardType(value) {
  if (!value) {
    return "Please select a medicare card type.";
  }
  if (!options.includes(value)) {
    return "Please choose your medicare card type.";
  }
};
export default validMedicareCardType;